import React from 'react';
import { StyleSheet, View } from './base_components';
import ProgressSpinner from './progress_spinner';
import Plan from './plan';

import { usePlanList, fetch } from '../stores/plan_store';

const styles = StyleSheet.create({
  planList: {
    paddingLeft: '1rem',
    paddingRight: '1rem',
    alignSelf: 'stretch',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  plan: {
    marginTop: '2rem',
    marginBottom: '2rem',
    alignSelf: 'stretch',
    justifyContent: 'space-between',
    backgroundColor: 'white',
  },
});

const ENTERPRISE = {
  plan_id: 'enterprise',
  plan_name: 'Enterprise',
};

export default function PlanList(props) {
  const list = usePlanList();
  React.useEffect(() => {
    fetch();
  }, []);
  let content: any = null;
  if (list?.length > 0) {
    content = list.map((plan, i) => {
      let ret: any = null;
      if (
        props.excludePlan?.plan_id !== plan.plan_id &&
        plan.plan_frequency === 'MONTH'
      ) {
        ret = (
          <Plan
            key={i}
            style={styles.plan}
            plan={plan}
            onPress={props.onPress}
          />
        );
      }
      return ret;
    });
    if (!props.excludePlan?.plan_id?.startsWith('enterprise')) {
      content.push(
        <Plan
          key='enterprise'
          style={styles.plan}
          plan={ENTERPRISE}
          onPress={props.onPress}
        />
      );
    }
  } else {
    content = <ProgressSpinner />;
  }
  return <View style={[styles.planList, props.style]}>{content}</View>;
}
